(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
      })();
      (function() {
  if (!__sections__["marquee"] && !window.DesignMode) return;
  try {
    
  class InfiniteMarkquee extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.container = this.querySelector('[data-marquee-container]');

      if (!this.container) {
        return;
      }

      this.marquee = new InfiniteMarquee({
        element: this.container,
        speed: Number(this.dataset.interval),
        spaceBetween: '36px',
        pauseOnHover: true,
        breakpointSize: 770,
        mobileSettings: {
          spaceBetween: '24px'
        }
      });
    }
  }

  customElements.define('infinite-marquee', InfiniteMarkquee);

  } catch(e) { console.error(e); }
})();
      })();
